var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardTypeNum',{attrs:{"card-type":_vm.cardType,"expiring-soon-tip":_vm.expiringSoonTip,"residue-number":_vm.residueNumber,"expire-number":_vm.expireNumber}},[_c('p',{staticClass:"tip-txt"},[_c('a-icon',{staticClass:"tip-icon",attrs:{"type":"exclamation-circle"}}),_vm._v(" 名额不足或管理员未审核，不影响建组，但学生无法上课 ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }